export default __webpack_public_path__ + "static/media/di5.2867d786.jpg";